import { Question } from "../../models/Question";
import { QuizSubmissionRequest } from "../../models/QuizSubmission";
import { slavtHTTP } from "../http";

export function getQuestionDetails(quizId: string, questionId: string) {
  return slavtHTTP
    .get<Question>(`/quizzes/${quizId}/questions/${questionId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function createQuestion(quizId: string, question: Question) {
  return slavtHTTP
    .post<{ id: number }>(`/quizzes/${quizId}/questions`, question)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function editQuestion(
  quizId: string,
  questionId: string,
  question: Question,
) {
  return slavtHTTP
    .patch<{ id: number }>(
      `/quizzes/${quizId}/questions/${questionId}`,
      question,
    )
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function deleteQuestion(quizId: number, questionId: string) {
  return slavtHTTP
    .delete<void>(`/quizzes/${quizId}/questions/${questionId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function createQuizSubmission(
  quizId: string,
  submission: QuizSubmissionRequest,
) {
  return slavtHTTP
    .post<void>(`/quizzes/${quizId}/submissions`, submission)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}
